import { c as _c } from "react/compiler-runtime";
import { useProductBuilderContext } from "./ProductBuilderContext";
export default function Headline() {
  const $ = _c(2);
  const {
    product
  } = useProductBuilderContext();
  if (!product.headline) {
    return null;
  }
  let t0;
  if ($[0] !== product.headline) {
    t0 = <h2 className="text-xl">{product.headline}</h2>;
    $[0] = product.headline;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
}